import styled from 'styled-components';

export const InstructionsWrapper = styled.div`
	background-color: #ffffff;
	height: 100%;
	width: 100%;
	padding: 20px;
`;

export const InstructionHeader = styled.div`
	font-weight: 500;
	font-size: 19px;
`;

export const Instruction = styled.li`
	list-style: disc;
	padding-top: 10px;
`;

export const InstructionList = styled.ul`
	padding: 5px 10px 10px 30px;
`;

export const BoldText = styled.span`
	font-weight: 500;
`;
